var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrpdwicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1783_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7881 36.0864V19.6663H26.2975L27.124 13.2652H20.7881V9.17907C20.7881 7.32638 21.3005 6.0638 23.9603 6.0638L27.347 6.06241V0.33704C26.7613 0.260927 24.7509 0.0864258 22.4109 0.0864258C17.5246 0.0864258 14.1794 3.06896 14.1794 8.54511V13.2652H8.65332V19.6663H14.1794V36.0864H20.7881Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1783_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.0864258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrpdwicon3);
export default __webpack_public_path__ + "static/media/drpdwicon3.3e7369361982f178bf8a3b09d0368978.svg";
export { ForwardRef as ReactComponent };